// Suppliers State
import i18n from '@/i18n'

export default {
  suppliersList: [],
  supplierInfo: {},
  fullVendersList: [],
  supplierTypeList: [{ text: i18n.t('Company'), value: 'Company' }, { text: i18n.t('Individual'), value: 'Individual' }]
}
